<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 
-->
<template>
    <jh-base-dialog
        :title="stepDialogConfig.title"
        :visible="stepDialogVisible"
        append-to-body
        width="1000px"
        @close="close"
    >
        <template slot="body">
            <el-steps class="step" :active="active" finish-status="success">
                <el-step
                    v-for="item in stepList"
                    :key="item.natitleme"
                    :title="item.title"
                ></el-step>
            </el-steps>
            <div class="content" v-show="active == 0" >
                <el-form :model="form" ref="form" label-width="150px" label-position="right">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="申请数量" prop="applySqsl">
                                <el-input-number v-model="form.applySqsl"  :min="1" label="请输入数量" ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="标签样式" prop="tagYs">
                                <enuSelect style="width:100%;" filterable v-model="form.tagYs" :list='bqysList' placeholder="请选择标签样式" ></enuSelect>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="标签规格" prop="tagGg">
                                <enuSelect style="width:100%;" filterable v-model="form.tagGg" :list='bqggList' placeholder="请选择标签规格" ></enuSelect>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="申请人姓名" prop="applyUserName">
                                <el-input v-model="form.applyUserName"  placeholder="请输入申请人姓名" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="申请时间" prop="applyTime">
                                <el-input v-model="form.applyTime"  placeholder="请输入申请时间" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注" >
                                <el-input type="textarea" :rows="2" v-model="form.applyDesc"  placeholder="请输入备注" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="content" v-show="active == 1">
                <tagBatch :tagApplyId="tagApplyId"  @onSuccess="getData"></tagBatch>
            </div>
            <div class="content" v-show="active == 2">
                <el-form :model="form1" ref="form1" label-width="150px" label-position="right">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="实际发货量" prop="handFhl">
                                <el-input-number v-model="form1.handFhl"  :min="1" label="请输入数量" ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="物流单号" prop="handWldh">
                                <el-input v-model="form1.handWldh"  placeholder="请输入物流单号" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="content" v-show="active == 3">
                <span>请确认是否已签收</span>
            </div>
        </template>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="active > 0" type="primary" @click="upConfirm">上一步</el-button>
            <el-button @click="close">取 消</el-button>
            <el-button v-if="active == 2" @click="saveApply">保 存</el-button>
            <el-button v-if="active == 3" @click="saveQs">保 存</el-button>
            <el-button type="primary" @click="confirm">下一步
                <!-- {{ active === 1 ? '生成并下载' : '下一步' }} -->
            </el-button>
        </span>
    </jh-base-dialog>
</template>

<script>
export default {
    components: {
        tagBatch: (resolve) => resolve(require("../tagBatch/tagBatch.vue")),
    },
    name: 'stepDialog',
    props: {
        stepDialogVisible: {
            type: Boolean,
            default: false,
        },
        stepDialogConfig: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            tagApplyId:'',
            bqysList:[],
            bqggList: [],
            tagApplyId:'',
            active: 0,
            stepList: [{ title: '申请信息' }, { title: '处理信息' }, { title: '物流信息' },{ title: '签收信息' }],
            form: {
                tagApplyId: '',
                applySqsl: '',
                tagYs: '',
                tagGg: '',
                tagZt: '',
                applyUserId: '',
                applyUserName: '',
                applyTime: '',
                applyDesc: '',
                createName: '',
                createId: '',
                createTime: '',
                handFhl: '',
                handUserId: '',
                handUserName: '',
                handTime: '',
            },
            form1: {
                tagApplyId: '',
                handFhl: 1,
                handWldh: '',
                tagZt:'2',
            },
        };
    },

    computed: {},

    created() {},
    mounted(){
        this.bqysList = this.stepDialogConfig.bqysList;
        this.bqggList = this.stepDialogConfig.bqggList;
        this.bqztList = this.stepDialogConfig.bqztList;
        if (this.stepDialogConfig.data) {
            for (const key in this.stepDialogConfig.data) {
                for (const k in this.form) {
                    if (key === k) {
                        this.form[k] = this.stepDialogConfig.data[key];
                    }
                }
                for (const k in this.form1) {
                    if (key === k) {
                        this.form1[k] = this.stepDialogConfig.data[key];
                    }
                }
            }
        }
        this.tagApplyId = this.form.tagApplyId;
        this.form1.tagApplyId = this.form.tagApplyId;
        this.active = parseInt(this.form.tagZt);
    },

    methods: {
        close() {
            this.$emit('update:stepDialogVisible', false);
        },
        valid() {
            return new Promise((resolve, reject) => {
                this.$refs.cpt.validate().then((res) => {
                    console.log(res);
                    resolve(res);
                });
            });
        },
        validate() {
            return new Promise((resolve, reject) => {
                resolve();
            });
        },
        confirm(){
            this.active++;
        },
        upConfirm(){
            this.active--;
        },
        saveApply(){
            this.$refs.form1.validate((valid) => {
                if (valid) {
                    let params = JSON.parse(JSON.stringify(this.form1));
                        this.$api
                            .formPost("/api/major/tag/tagApply/doHandById", params)
                            .then((res) => {
                                this.$message.success("操作成功");
                                this.close();
                                this.$emit("onSuccess");
                            });
                }
            });
        },
        saveQs(){
            this.$api
                .formPost("/api/major/tag/tagApply/doHandById", {
                    tagApplyId:this.tagApplyId,
                    tagZt:'3',
                })
                .then((res) => {
                    this.$message.success("操作成功");
                    this.close();
                    this.$emit("onSuccess");
                });
        },
        getData(){
            this.$emit("onSuccess");
        },
    },
};
</script>
<style lang="scss" scoped>
.step {
    display: flex;
    padding: 10px 20%;
}
.content {
    height: 50vh;
    overflow: auto;
    margin-left: 25vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/tag/tagApplyHand/handStep.vue